<template>
  <nav>
    <AlertMessages
      v-if="alertValue"
      :alert-type="alertType"
      :alert-msg="alertMsg"
      @reset="alertValue = false"
    />
    <DashboardHeader />
    <v-row v-if="mobile()">
      <v-col
        cols="11"
        class="d-flex justify-end mt-n3 mx-auto"
      >
        <SearchBarGlobal
          :space-id="spaceId"
          :size-activities="sizeActivities"
          :size-hubs="sizeHubs"
        />
      </v-col>
    </v-row>
    <v-row v-else :class="role == 'booster' || role == 'space_admin' ? '' : 'mt-n14'">
      <v-col
        cols="4"
        class="mx-auto mt-n4 d-flex justify-end"
      >
        <SearchBarGlobal
          :space-id="spaceId"
          :size-activities="sizeActivities"
          :size-hubs="sizeHubs"
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col align="center"  data-testid="dashboard-info" class="no-break">
        <!-- <span class="text-h6">{{ $t('dashboardTitleLabel') }}</span> -->
        <p class="text-h6" v-if="dashboard_title != null">{{dashboard_title}}</p>
        <p class="text-h6" v-else>{{$t('dashboardTitleLabel')}}</p>
        <!-- <span class="text-h6">{{ $t('dashboardTextLabel') }}</span> -->
        <p class="greytext--text" v-if="dashboard_text != null">{{dashboard_text}}</p>
        <p class="greytext--text" v-else>{{$t('dashboardTextLabel')}}</p>
      </v-col>
    </v-row>
    <v-row
      v-if="activities.length == 0 && hubs.length == 0 && !loadingData"
      align="center"
      class="mt-16"
    >
      <v-col
        cols="12"
        sm="8"
        md="6"
        offset-sm="2"
        offset-md="3"
        align="center"
      >
        <EmptyPage
          page-image="image2"
          :page-text="$t('emptyDashboardTextParticipant')"
        />
      </v-col>
    </v-row>
    
    <v-row
      v-if="hubs.length > 0 && !loadingData"
      class="mx-auto"
    >
      <v-col
        align="center"
        :cols="mobile() ? '12' : '11'"
        :class="mobile() ? '' : 'mx-auto px-0'"
      >
        <v-row no-gutters>
          <v-col
            cols="6"
            class="d-flex justify-start"
          >
            <!-- <p class="text-h5 font-weight-bold">
              {{ $t('hubs') }}
            </p> -->
          </v-col>
          <v-col
            v-if="hubsTotal >= 4"
            cols="6"
            class="d-flex justify-end"
          >
            <a @click="showhubPage">{{ $t('seeAll') }}
            </a>
          </v-col>
        </v-row>
        <v-row align="center">
          <v-col
            v-for="item in hubs"
            :key="item.id"
            cols="12"
            sm="6"
            xl="4"
          >
            <v-hover>
              <v-card
                slot-scope="{ hover }"
                height="300"
                data-testid="hub-card"
                rounded="xxl" 
                class="mx-auto rounded-xxl"
                :ripple="false"                        
                :class="`elevation-${hover? 8 : 2 } ${hover? 'v-card--shadow': 'v-card--flat'}`" 
                :to="'/hub/'+item.id"
              >
                <v-responsive class="rounded-b-0">
                  <v-img
                    class="rounded-t-xl"
                    :src="(item.attributes.image) ? item.attributes.image : require('../../assets/background-hub.jpg')"
                    height="120px"
                  >
                    <v-card-text class="py-5">
                      <v-row
                        no-gutters
                        class="mx-auto "
                      >
                        <v-col
                          class="d-flex align-start ml-2"
                          cols="12"
                          sm="12"
                          md="12"
                        >
                          <v-tooltip bottom>
                            <template v-slot:activator="{ on }">
                              <v-chip
                                small
                                data-testid="sharing-setting-chip"
                                color="darktext"
                                text-color="white"
                                filter-icon="mdi-equalizer-outline"
                                class="mr-4"
                                v-on="on"
                              >
                                <v-icon
                                  size="14"
                                  class="pr-1"
                                >
                                  mdi-share-variant
                                </v-icon>
                                <span v-if="item.attributes.sharing_setting == 'Restricted'">{{ $t('sharingSettingRestricted') }}</span>
                                <span v-if="item.attributes.sharing_setting == 'Open'">{{ $t('sharingSettingOpen') }}</span>
                              </v-chip>
                            </template>
                            <span v-if="item.attributes.sharing_setting == 'Restricted'">{{ $t('sharingSettingRestrictedHubTooltip') }}</span>
                            <span v-if="item.attributes.sharing_setting == 'Open'">{{ $t('sharingSettingOpenHubTooltip') }}</span>
                          </v-tooltip>
                          <v-chip
                            small
                            color="accent"
                          >
                            <span class="text-uppercase">{{ $t('hub') }}</span>
                          </v-chip>
                        </v-col>
                      </v-row>
                    </v-card-text>
                  </v-img>
                </v-responsive>
                <v-card-text class="pa-0">
                  <v-row no-gutters>
                    <v-col
                      cols="11"
                      sm="11"
                      md="11"
                      class="py-0"
                      style="height:70px"
                    >
                      <v-card-title
                        class="text-left no-break darktext--text"
                        style="line-height:inherit"
                      >
                        <v-clamp
                          autoresize
                          :max-lines="2"
                        >
                          {{ item.attributes.title }}
                        </v-clamp>
                      </v-card-title>
                    </v-col>
                    <v-col
                      cols="12"
                      sm="12"
                      md="12"
                      class="py-0"
                    >
                      <v-card-subtitle class="text-left text-body-1 greytext--text no-break darktext--text py-0">
                        <v-clamp
                          autoresize
                          :max-lines="3"
                        >
                          {{ item.attributes.description }}
                        </v-clamp>
                      </v-card-subtitle>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>
            </v-hover>
          </v-col>
        </v-row>
      </v-col>  
    </v-row>
    <v-row
      v-if="activities.length > 0 && !loadingData"
      class="mx-auto"
    >
      <v-col
        align="center"
        :cols="mobile() ? '12' : '11'"
        :class="mobile() ? '' : 'mx-auto px-0'"
      >
        <v-row no-gutters>
          <v-col
            cols="6"
            class="d-flex justify-start"
          >
            <!-- <p class="text-h5 font-weight-bold">
              {{ $t('activitiesItem') }}
            </p> -->
          </v-col>
          <v-col
            v-if="activitiesTotal >= 5"
            cols="6"
            class="d-flex justify-end"
          >
            <a @click="showActivityPage">{{ $t('seeAll') }}
            </a>
          </v-col>
        </v-row>
        <v-row align="center">
          <v-col
            v-for="item in activities"
            :key="item.id"
            cols="12"
            sm="6"
            lg="3"
            xl="3"
          >
            <v-hover>
              <v-card
                slot-scope="{ hover }"
                height="345"
                data-testid="activity-card"
                rounded="xxl" 
                class="mx-auto rounded-xxl"
                :ripple="false"
                :class="`elevation-${hover? 8 : 2 } ${hover? 'v-card--shadow': 'v-card--flat'}`"
                :to="'/activity/'+item.id"
              >
                <v-responsive class="rounded-b-0">
                  <v-img
                    class="rounded-t-xl"
                    :src="(item.attributes.image) ? item.attributes.image : require('../../assets/cover-activity.jpg')"
                    height="195px"
                  />
                </v-responsive>
                <v-card-text class="pa-0" style="height: 80px;">
                  <v-row>
                    <v-col
                      cols="12"
                      sm="12"
                      md="12"
                      class="py-0"
                      style="height:80px"
                    >
                      <v-card-title class="text-left darktext--text no-break px-4 py-2">
                        <v-clamp
                          autoresize
                          :max-lines="2"
                        >
                          {{ item.attributes.title }}
                        </v-clamp>
                      </v-card-title>
                    </v-col>
                  </v-row>
                </v-card-text>
                <v-card-actions class="pa-0" style="height: 70px;">
                  <v-row
                    class="mx-auto fill-height pa-2"
                  >
                    <v-col
                      cols="12"
                      sm="12"
                      md="12"
                      class="d-flex align-end px-4 py-0"
                    >
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on }">
                          <v-chip
                            small
                            data-testid="sharing-setting-chip"
                            color="darktext"
                            text-color="white"
                            filter-icon="mdi-equalizer-outline"
                            v-on="on"
                          >
                            <v-icon
                              size="14"
                              class="pr-1"
                            >
                              mdi-share-variant
                            </v-icon>
                            <span v-if="item.attributes.sharing_setting == 'Restricted'">{{ $t('sharingSettingRestricted') }}</span>
                            <span v-if="item.attributes.sharing_setting == 'Flexible'">{{ $t('sharingSettingFlexible') }}</span>
                            <span v-if="item.attributes.sharing_setting == 'Open'">{{ $t('sharingSettingOpen') }}</span>
                          </v-chip>
                        </template>
                        <span v-if="item.attributes.sharing_setting == 'Restricted'">{{ $t('sharingSettingRestrictedTooltip') }}</span>
                        <span v-if="item.attributes.sharing_setting == 'Flexible'">{{ $t('sharingSettingFlexibleTooltip') }}</span>
                        <span v-if="item.attributes.sharing_setting == 'Open'">{{ $t('sharingSettingOpenTooltip') }}</span>
                      </v-tooltip>
                    </v-col>
                    <v-col>
                      <v-progress-linear :value="item.meta.statistics.data.percentage" :color="item.meta.statistics.data.percentage == 0 ? 'greytextlight' : 'success'" height="16" class="rounded-xxl" data-testid="progress-linear"><span class="text-caption">{{ item.meta.statistics.data.percentage }}%</span></v-progress-linear>
                    </v-col>
                  </v-row>
                </v-card-actions>
              </v-card>
            </v-hover>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </nav>
</template>

<script>
import i18n from '../../plugins/i18n'
import { getSharedActivities } from '../../api/activityApi'
import { getSharedHubs } from '../../api/hubApi'
import EmptyPage from '../../components/EmptyPage'
import VClamp from 'vue-clamp'
import { repeatedMethodsMixin } from '../../mixins/repeatedMethodsMixin'
import AlertMessages  from '../../components/AlertMessages'
import DashboardHeader from '../../components/DashboardHeader'
import SearchBarGlobal from '../../components/SearchBarGlobal'

export default {
    components: {
        EmptyPage,
        VClamp,
        AlertMessages,
        DashboardHeader,
        SearchBarGlobal
    },
    mixins: [repeatedMethodsMixin],

    data(){
        return{
            dashboard_title: localStorage.space ? JSON.parse(localStorage.space).dashboard_title : '',
            dashboard_text: localStorage.space ? JSON.parse(localStorage.space).dashboard_text : '',
            activities: [],
            hubs: [],
            spaceId: window.$cookies.get('space_id'),
            alertMsg:'',
            alertValue:false,
            alertType:'success',
            pageNumber: 1,
            pageNumberActivities: 1,
            loadingData: false,
            activitiesTotal: 0,
            hubsTotal: 0,
            role: localStorage.space ? JSON.parse(localStorage.space).role : null,
        }
    },
    computed: {
      size() {
        switch (this.$vuetify.breakpoint.name) {
          case 'xl': return 3
          default: return 2
        }
      },
      sizeActivities() {
        switch (this.$vuetify.breakpoint.name) {
          case 'xl': return 4
          default: return 6
        }
      },
      sizeHubs() {
        switch (this.$vuetify.breakpoint.name) {
          case 'xl': return 3
          default: return 2
        }
      },
      productPlan() {
        return this.$store.state.productPlan;
      },
    },
    watch: {
     productPlan: {
      immediate: true,
      handler(to) {
        if (to) {
          //handle your changes
            if(this.productPlan.attributes && this.productPlan.attributes.name != 'Free'){
              this.fetchSharedHubs()
          }
        }
      },
    },
    },
    async created(){
        if(this.$route.params.acceptedInvitationRegistered){
          this.alertMsg = i18n.t('joinSpaceAndRegisterSucccess')
          this.alertValue = true
        }
        if(this.$route.params.acceptedInvitation){
            this.alertMsg = i18n.t('joinSpaceSucccess')
            this.alertValue = true
        }
        this.loadingData = true
        await this.fetchSharedActivities()
        if(this.productPlan.attributes && this.productPlan.attributes.name != 'Free'){
          await this.fetchSharedHubs()
        }
        this.loadingData = false
        
    },
    methods:{
        showhubPage(){
            this.$router.push({path: '/all-hubs-participant'})
        },
        showActivityPage(){
            this.$router.push({path: '/all-activities-participant'}) 
        },
        seeAll(){
            this.$router.push({path: '/dashboard-participant'}) 
        },
        async fetchSharedActivities(){
            try {
                const response = await getSharedActivities(this.spaceId, this.pageNumberActivities, this.sizeActivities)
                if(response.status){
                    if(response.status == 200) {
                        this.activities = response.data.data
                        this.activitiesTotal = response.data.meta.page.total
                        window.scrollTo(0,0)                       
                    }
                }
            } catch (e) {
                if(e.response){
                    this.alertType = 'error'
                    this.alertMsg =  i18n.t('serverError')
                    this.alertValue = true
                }
            }
        },
        async fetchSharedHubs(){
            try {
                const response = await getSharedHubs(this.spaceId,this.pageNumber, this.size)
                if(response.status){
                    if(response.status == 200) {
                        this.hubs = response.data.data
                        this.hubsTotal = response.data.meta.page.total
                        window.scrollTo(0,0)
                    }
                }
            } catch (e) {
                if(e.response){
                    this.alertType = 'error'
                    this.alertMsg =  i18n.t('serverError')
                    this.alertValue = true
                }
            }
        }
     }
}
</script>
